// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3iWR5","paramInput":"JobSimulator_paramInput__1zbSB","input":"JobSimulator_input__36BOU"};